import {ENDPOINT_ADMIN_FAILED_AUCTIONS_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const loopMap = require('mn-utils/loopMap');
const map = require('mn-utils/map');
const {
  apiRequestAdmin,
} = require('../ws');


const MOCK_FAILED_AUCTIONS = loopMap(100, (i) => {
  const id = '' + (1 + i);
  const uuid = 'c8e846db-71cf-4a87-8f71-1220ac7bc995' + id;
  return {
    id: uuid,
    time: '2020-02-17T12:07:45',
    merchant: uuid,
    merchant_login: 'merchant_login',
    arbitrator: uuid,
    arbitrator_login: 'arbitrator_login',
    exchange: uuid,
    exchange_name: 'exchange_name',
    cc_code: 'cc_code',
    cc_value: 0.1,
    sc_code: 'sc_code',
    sc_value: 0.1,
    auction_status: 'auction_status',
    exchange_rate: 0.1,
    payment_status: 'payment_status',
    tx_hash: 'tx_hash',
    order_status: 'order_status',
    difference: 'Option',
  };
});

export function apiAdminFailedAuctionsList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      list: MOCK_FAILED_AUCTIONS.slice(offset, offset + limit),
      count: MOCK_FAILED_AUCTIONS.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_FAILED_AUCTIONS_LIST, {
    ...params,
    offset,
    limit,
    tx_blockchain_id: params.id,
  }).then((v) => {
    return {
      ...v,
      list: map(v.list, (v) => {
        return {
          ...v,
          payment_status: v.order_status || v.payment_status,
          time: v.date_time || v.time,
        };
      }),
    };
  });
}
